var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReuse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 93,
    viewBox: "0 0 90 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1238 67.6853C14.1238 67.6853 20.6258 87.235 45 93V85.7339C69.853 85.7339 90 70.0397 90 45.1215C90 20.2035 69.853 0 45 0C20.1501 0 0 20.2035 0 45.1215C0 47.3514 0.166655 49.5406 0.475759 51.6831C3.44359 32.5758 19.9583 17.6686 43.8744 12.924C44.0671 10.4119 44.2604 7.89252 44.4817 5.02684C64.0105 8.55627 74.9986 29.2947 74.9986 29.2947C74.9986 29.2947 65.4986 46.5003 45.2908 52.7635L45.3265 42.7723C21.9029 50.2949 14.1238 67.6853 14.1238 67.6853Z",
    fill: "#58A291"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReuse);
export default __webpack_public_path__ + "static/media/icon-reuse.8e2a693daf79ed7a0d8799cb1f7039a3.svg";
export { ForwardRef as ReactComponent };